export default {
	acceptAndJoin: "Accepter et rejoindre le Temple",
	acceptInvite: "Accepter l'invitation",
	code: "Code d'invitation",
	createAccount: "Créez votre compte",
	displayName: "Nom complet",
	enterCode: "Entrez le code d'invitation que vous avez reçu",
	error: "Erreur lors de la création du compte. Veuillez réessayer.",
	invalidCode: "Code invalide ou expiré",
	invitedTo: "Vous avez été invité(e) à ce temple",
	joiningTemple: "Vous rejoignez le temple : {temple}",
	loggedInAs: "Vous êtes connecté(e) en tant que {name} ({email})",
	ritualFunction: "Fonction au Temple",
	ritualFunctionHint: "Ex. : Médium, Cambono, Ogã (facultatif)",
	submit: "Créer le compte",
	title: "Rejoindre en tant que membre",
	validate: "Valider le code",
};
